import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";

export const dividendReport = (user: User, divid: string) => {

//	  console.log("Poziva se getTradeApi sa:", { user, divid });

	return httpWebApi<Blob>({
		method: "GET",
		responseType: "blob",
		timeout: 60 * 4 * 1000,
		url: "reporting/getdividendreport",
		params: {
			userid: user.userId,
			divid,
		},
	});
};

export default dividendReport;
